import type { API } from 'chessboard/api/config/types';
import type JCE from '@chesscom/js-chess-engine';

/**
 * Create the getCurrentFullLine method.
 */
export function createGetCurrentFullLine(context: API.Context) {
  /**
   * Get the full line, following all variations, to the selected node.
   */
  return function getCurrentFullLine(): JCE.Node.Model[] {
    const { game } = context;

    return game.history({ toCurrent: true, verbose: true });
  };
}
